import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .FDSSearchInputContainer': {
    width: '100%',
    display: 'flex',
    borderRadius: theme.spacing(0.5),
    border: `2px solid ${theme.palette.divider[5]}`,
    background: theme.palette.background.secondary,
    backdropFilter: `blur(${theme.spacing(1)})`,
    overFlow: 'hidden',
    alignItems: 'stretch',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up('lg')]: {
      maxWidth: theme.typography.pxToRem(600),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
    },
  },
  '& .FDSearchBtn': {
    borderRadius: theme.spacing(0, 0.5, 0.5, 0),
    width: theme.typography.pxToRem(56),
    minWidth: 'unset',
    flex: 'none',
  },
  '& .FDSSearchInput': {
    '& .MuiInputBase-input': {
      padding: theme.spacing(1.75, 3),
      fontSize: theme.spacing(2),
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  },
  '& .FDSearchBtnIcon': {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  '& .FDSTabsContiner': {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
    },
  },
  '& .FDSTabs': {
    position: 'relative',
    '&::after ': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '1px',
      backgroundColor: theme.palette.divider[7],
    },
    '& .MuiTabs-indicator ': {
      display: 'none',
    },
    '& .MuiTabs-scrollButtons': {
      display: 'none',
    },
    '& .FDSTab': {
      fontWeight: 700,
      color: theme.palette.common.white,
      opacity: 0.7,
      '&.Mui-selected': {
        opacity: 1,
        borderBottom: `1px solid ${theme.palette.common.white}`,
      },
    },
  },
  '& .FDSQuestionsContainer':{
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(12.5),
     [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(3),
    },
  },
  '& .FDSResultText':{
    paddingTop: theme.typography.pxToRem(30),
    marginBottom: theme.typography.pxToRem(52),
  },
  '& .FDSCatigoryTitle':{
    marginBottom: theme.typography.pxToRem(38),
     [theme.breakpoints.down('md')]: {
      marginTop: theme.typography.pxToRem(22),
    },
  },
  '& .FDSCatigoryContainer':{
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
       marginTop: theme.spacing(2),
    },
  },
}));

export default StyledBox;
